module.exports = __webpack_public_path__ + "static/media/lista-hero-bulb.067d264d.png";